import { useEffect, useState } from 'react';

import {
  fetchMaestroOrgPermissions,
  MaestroOrgPermissions,
} from './maestro-org-api';

const NONE: MaestroOrgPermissions = {
  canViewSettings: false,
  canManageSettings: false,
  canViewSecrets: false,
  canManageSecrets: false,
};

/** Null while loading; a failed read grants nothing, so the tabs fail closed. */
export function useMaestroOrgPermissions(
  accountId: string
): MaestroOrgPermissions | null {
  const [permissions, setPermissions] = useState<MaestroOrgPermissions | null>(
    null
  );

  useEffect(() => {
    let current = true;
    setPermissions(null);
    fetchMaestroOrgPermissions(accountId).then(
      (loaded) => current && setPermissions(loaded),
      () => current && setPermissions(NONE)
    );
    return () => {
      current = false;
    };
  }, [accountId]);

  return permissions;
}
